import {Loqate as LoqateClient} from "@loqate/core";

const LOQATE_KEY = "RF49-FX99-TJ96-MJ49";

export const loqate = new LoqateClient({
    apiKey: LOQATE_KEY,
});
